type Corners = { x: number; y: number }[];

/** One decode, tagged with the image and expected code it was read for. */
export interface DecodedScan {
  imageBlobUrl: string;
  expectedQr: string;
  value: string | null;
  corners: Corners | null;
}

export interface CurrentScanResult {
  /** The current page's image is loading or not decoded yet. */
  pending: boolean;
  value: string | null;
  corners: Corners | null;
  result: 'match' | 'mismatch' | null;
}

const PENDING: CurrentScanResult = {
  pending: true,
  value: null,
  corners: null,
  result: null
};

/**
 * The scan result for the page on screen NOW, or pending while its image is
 * still loading or undecoded. A decode for any other image or expected code is
 * hidden: returning the last result after a page change is what made the
 * backfill save the previous page's QR onto every page opened.
 */
export function currentScanResult(
  scan: DecodedScan | null,
  imageBlobUrl: string | null,
  expectedQr: string | null
): CurrentScanResult {
  if (!expectedQr) {
    return { pending: false, value: null, corners: null, result: null };
  }
  if (
    !imageBlobUrl ||
    !scan ||
    scan.imageBlobUrl !== imageBlobUrl ||
    scan.expectedQr !== expectedQr
  ) {
    return PENDING;
  }
  return {
    pending: false,
    value: scan.value,
    corners: scan.corners,
    result:
      scan.value === null
        ? null
        : scan.value === expectedQr
          ? 'match'
          : 'mismatch'
  };
}
